import { render } from "./passwordReset.vue?vue&type=template&id=6cd95a3e&scoped=true"
import script from "./passwordReset.vue?vue&type=script&lang=js"
export * from "./passwordReset.vue?vue&type=script&lang=js"

import "./passwordReset.vue?vue&type=style&index=0&id=6cd95a3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd95a3e"]])

export default __exports__